export const CLAIMS_TAB = 'CLAIMS_TAB';
export const POLICY_TAB = 'POLICY_TAB';
export const CASES_TAB = 'CASES_TAB';
export const CHATS_TAB = 'CHATS_TAB';
export const MASSNOTIFICATIONS_TAB = 'MASSNOTIFICATIONS_TAB';
export const USER_MANAGEMENT_TAB = 'USER_MANAGEMENT_TAB';
export const ANALYTICS_TAB = 'ANALYTICS_TAB';
export const MESSAGE_TEMPLATE_ADD_AND_EDIT = 'MESSAGE_TEMPLATE_ADD_AND_EDIT';
export const TRANSLATE_ACCESS = 'TRANSLATE_ACCESS';
export const CASE_VISIBILITY = 'CASE_VISIBILITY';
export const GROUP_MANAGEMENT = 'GROUP_MANAGEMENT';
export const USER_MANAGEMENT = 'USER_MANAGEMENT';
export const TEMPLATE_MANAGEMENT = 'TEMPLATE_MANAGEMENT';
export const PRIVACY_ALL_PRIVATE_HIDDEN = 'PRIVACY_ALL_PRIVATE_HIDDEN';
export const PRIVACY_ALL_PRIVATE_TYPES = 'PRIVACY_ALL_PRIVATE_TYPES';
export const OVERRIDE_CASE_VISIBILITY = 'OVERRIDE_CASE_VISIBILITY';
export const NEEDS_ATTENTION = 'NEEDS_ATTENTION';
export const NEEDS_ACTION = 'NEEDS_ACTION';
export const NOTES_ACCESS = 'NOTES_ACCESS';
export const FOCUSED_OPERATOR = 'FOCUSED_OPERATOR';
export const CHAT_ALL_INBOX = 'CHAT_ALL_INBOX';
export const ADMIN_NOTIFICATION_CONFIG = 'ADMIN_NOTIFICATION_CONFIG';
export const NOTE_REPLIES_ENABLED = 'NOTE_REPLIES_ENABLED';
export const ORG_INACTIVITY_AUTO_REPLY = 'ORG_INACTIVITY_AUTO_REPLY';
export const ORG_SETTINGS_USER_MESSAGE_PREFIX =
  'ORG_SETTINGS_USER_MESSAGE_PREFIX';
export const PREFIX_CLAIM_NUMBER = 'PREFIX_CLAIM_NUMBER';
export const PREFIX_PHONE_NUMBER = 'PREFIX_PHONE_NUMBER';
export const PREFIX_USER_TITLE = 'PREFIX_USER_TITLE';
export const OPERATOR_TITLE = 'OPERATOR_TITLE';
export const TITLE_EDIT_ONLY_ADMIN = 'TITLE_EDIT_ONLY_ADMIN';
export const SYSTEM_ADMIN = 'SYSTEM_ADMIN';
export const ORG_SETTINGS_AUTO_MESSAGE_PREFIX =
  'ORG_SETTINGS_AUTO_MESSAGE_PREFIX';
export const LINES_OF_BUSINESS_ENABLE = 'LINES_OF_BUSINESS_ENABLE';
export const WEBAPP_CASE_CREATION = 'WEBAPP_CASE_CREATION';
export const PARTNER_CONFIG_VIEWER = 'PARTNER_CONFIG_VIEWER';
export const PARTNER_CONFIG_EDITOR = 'PARTNER_CONFIG_EDITOR';
export const TOTAL_LOSS_ASSIST = 'TOTAL_LOSS_ASSIST';
export const FEATURE_FLAG_IMAGE_REDACTION = 'FEATURE_FLAG_IMAGE_REDACTION';
export const IMAGE_REDACTION = 'IMAGE_REDACTION';
export const MANUAL_OPT_IN = 'MANUAL_OPT_IN';
export const AUTO_OPT_IN_USERS = 'AUTO_OPT_IN_USERS';
export const INTEGRATION_CONFIG_VERISK_ENABLED =
  'INTEGRATION_CONFIG_VERISK_ENABLED';
export const FNOL_UI = 'FNOL_UI';
export const REDACTION_VIEW_ACCESS = 'REDACTION_VIEW_ACCESS';
export const CREATE_CLAIMS_FROM_CASES_TAB = 'CREATE_CLAIMS_FROM_CASES_TAB';
export const CREATE_POLICY_FROM_CASES_TAB = 'CREATE_POLICY_FROM_CASES_TAB';
export const SERVICE_CASE_MANAGEMENT = 'SERVICE_CASE_MANAGEMENT';
export const SERVICE_CALL_FORWARDING = 'SERVICE_CALL_FORWARDING';
export const RESTRICT_CASE_EDITING = 'RESTRICT_CASE_EDITING';
export const RESTRICT_CHAT_PARTICIPANT_CONFIGURATION =
  'RESTRICT_CHAT_PARTICIPANT_CONFIGURATION';
export const RESTRICT_SURVEY_UI = 'RESTRICT_SURVEY_UI';
export const RESTRICT_SEND_MESSAGE = 'RESTRICT_SEND_MESSAGE';
export const RESTRICT_CASE_ACTIONS = 'RESTRICT_CASE_ACTIONS';
export const RESTRICT_CASE_ASSIGNMENT = 'RESTRICT_CASE_ASSIGNMENT';
export const RESTRICT_NOTES_EDITING = 'RESTRICT_NOTES_EDITING';
export const RESTRICT_TRANSLATE_EDITING = 'RESTRICT_TRANSLATE_EDITING';
export const DISPLAY_UNIQUE_ID_WITH_USER_NAME =
  'DISPLAY_UNIQUE_ID_WITH_USER_NAME';
export const ALLOW_UNASSIGNED_CASES = 'ALLOW_UNASSIGNED_CASES';
export const DISPLAY_CASE_ROLE_TYPE_BADGE = 'DISPLAY_CASE_ROLE_TYPE_BADGE';
export const VIETNAMESE_TRANSLATION = 'VIETNAMESE_TRANSLATION';
export const NORMALIZE_DATE_OF_LOSS_DISPLAY = 'NORMALIZE_DATE_OF_LOSS_DISPLAY';
export const FEATURE_FLAG_UNADDRESSED_ENABLED =
  'FEATURE_FLAG_UNADDRESSED_ENABLED';
export const REDSHIFT_MY_TEAMS_DASHBOARD = 'REDSHIFT_MY_TEAMS_DASHBOARD';
export const REDSHIFT_MARTS_MY_TEAM = 'REDSHIFT_MARTS_MY_TEAM';
export const FEATURE_FLAG_ENABLE_FABRIC_AGENTS =
  'FEATURE_FLAG_ENABLE_FABRIC_AGENTS';
export const FEATURE_FLAG_MANUAL_ATTACH_AGENT_TO_CASE =
  'FEATURE_FLAG_MANUAL_ATTACH_AGENT_TO_CASE';
export const FEATURE_FLAG_AI_TRANSLATION = 'FEATURE_FLAG_AI_TRANSLATION';
export const EMOJIS = 'EMOJIS';
export const DATA_DOWNLOAD = 'DATA_DOWNLOAD';
export const QUEUES = 'QUEUES';
export const QUEUES_TAB = 'QUEUES_TAB';
export const MTLS_CONFIG_UI = 'MTLS_CONFIG_UI';
export const QUEUE_MANAGEMENT = 'QUEUE_MANAGEMENT';
export const MULTI_PARTY_TEXTING = 'MULTI_PARTY_TEXTING';
export const MESSAGE_STATUS = 'MESSAGE_STATUS';
export const OAUTH_2_UI = 'OAUTH_2_UI';
export const PERSISTENT_SECONDARY_OPERATOR = 'PERSISTENT_SECONDARY_OPERATOR';
export const LOCALIZATION_SETTINGS = 'LOCALIZATION_SETTINGS';
export const FEATURE_FLAG_EVENT_MESSAGE_REDESIGN =
  'FEATURE_FLAG_EVENT_MESSAGE_REDESIGN';
export const FEATURE_FLAG_ACTIONABLE_GREY_MESSAGES =
  'FEATURE_FLAG_ACTIONABLE_GREY_MESSAGES';
export const IS_ALIAS_OPERATOR = 'IS_ALIAS_OPERATOR';
